export const ALLOWED_REFERRAL_PROPERTY_TYPES = ['Apartaestudio', 'Apartamento', 'Casa', 'Casa campestre', 'Finca'];

export const DEFAULT_PROPERTY_IMAGE = 'https://storage.googleapis.com/portal-brokers-ciencuadras.firebasestorage.app/no-photo-property.jpg';

// Brand colors
export const CIEN_CUADRAS_BLUE = '#005A9E';
export const CIEN_CUADRAS_BUTTON_BLUE = '#0073b7';

// Short code mappings for property categories
export const shortCodeMap: Record<string, string> = {
  c: 'coleccion_inmuebles',
  a: 'coleccion_inmuebles',
  b: 'coleccion_inmuebles',
};
